import _ from 'lodash'
import EntityModel from '@/Modules/Entity/EntityModel.js'
import DocumentModel from '@/Modules/Document/DocumentModel.js'
import { i18n } from '@/Setup/SetupI18n.js'
import PermissionModel from '@/Modules/Permission/PermissionModel.js'

const ACTIVE_STATUS = 'active'
const DRAFT_STATUS = 'draft'
const CANCELLED_STATUS = 'cancelled'

export const SENDER_TYPE_USER = 'user'
export const SENDER_TYPE_SYSTEM = 'system'
export const SENDER_TYPE_CUSTOM = 'custom'

export const EmailTemplateModelType = Object.freeze({
  quote: 'quote',
  invoice: 'invoice',
  client: 'client',
  notification: 'notification',
})

export const EmailTemplateDefaultLocale = 'en_US'

export default class EmailTemplateModel {
  id = null
  name = null
  type = 'quote'
  tag = null
  subject = null
  fromAddress = null
  senderType = SENDER_TYPE_SYSTEM
  status = DRAFT_STATUS
  ccAddresses = []
  bccAddresses = []
  toAddresses = []
  body = null
  entityId = null
  entity = null
  schemaReference = null
  schemaVersion = null
  documents = []
  locale = EmailTemplateDefaultLocale
  canManual = true
  subEmails = []
  permissionId = null
  permission = null

  constructor(data = {}) {
    _.forEach(data, (value, field) => {
      this[_.camelCase(field)] = value

      this.permission = data.permission && new PermissionModel(data.permission)
    })

    this.subEmails = []
    _.forEach(data.sub_emails, (value) => {
      this.subEmails.push(new EmailTemplateModel(value))
    })

    this.entity = data.entity && new EntityModel(this.entity)
    this.documents =
      data.documents &&
      _.map(data.documents, (document) => new DocumentModel(document))
  }

  static types() {
    return [
      {
        label: i18n.tc('common.quote'),
        value: EmailTemplateModelType.quote,
      },
      {
        label: i18n.tc('invoices.pre-title'),
        value: EmailTemplateModelType.invoice,
      },
      {
        label: i18n.tc('invoices.client'),
        value: EmailTemplateModelType.client,
      },
      {
        label: i18n.tc('email.notification'),
        value: EmailTemplateModelType.notification,
      },
    ]
  }

  static senderTypes() {
    return [
      {
        label: i18n.tc('common.user'),
        value: SENDER_TYPE_USER,
      },
      {
        label: i18n.tc('documents.system'),
        value: SENDER_TYPE_SYSTEM,
      },
      {
        label: i18n.tc('email.custom'),
        value: SENDER_TYPE_CUSTOM,
      },
    ]
  }

  static statuses() {
    return [
      {
        label: i18n.tc('statuses.active'),
        value: ACTIVE_STATUS,
      },
      {
        label: i18n.tc('statuses.draft'),
        value: DRAFT_STATUS,
      },
      {
        label: i18n.tc('statuses.canceled'),
        value: CANCELLED_STATUS,
      },
    ]
  }

  statusData() {
    switch (this.status) {
      case DRAFT_STATUS: {
        return {
          label: i18n.tc('statuses.draft'),
          badge: 'soft-secondary',
        }
      }
      case ACTIVE_STATUS: {
        return {
          label: i18n.tc('statuses.active'),
          badge: 'soft-success',
        }
      }
      case CANCELLED_STATUS: {
        return {
          label: i18n.tc('statuses.canceled'),
          badge: 'soft-danger',
        }
      }
    }
  }

  canSendEmail() {
    return this.type === EmailTemplateModelType.quote
  }

  get typeName() {
    const type = EmailTemplateModel.types().find(
      (item) => item.value === this.type
    )
    if (type?.label) {
      return type?.label
    }
  }
}
